import { Country, CreateCountryRequest, CreateCountryResponse } from '@/types/model';
import { apiClient } from './apiClient';

const COUNTRIES_ENDPOINT = '/countries';

export const countryService = {
  /**
   * Retrieve all countries (used for maintenance lists and dropdowns).
   */
  async getCountries(): Promise<Country[]> {
    return apiClient.get<Country[]>(COUNTRIES_ENDPOINT);
  },

  /**
   * Retrieve a single country by ID.
   */
  async getCountryById(id: string): Promise<Country> {
    return apiClient.getById<Country>(COUNTRIES_ENDPOINT, id);
  },

  /**
   * Create a new country.
   */
  async createCountry(countryData: CreateCountryRequest): Promise<CreateCountryResponse> {
    return apiClient.create<CreateCountryRequest, CreateCountryResponse>(COUNTRIES_ENDPOINT, countryData);
  },

  /**
   * Update an existing country.
   */
  async updateCountry(id: string, countryData: Partial<CreateCountryRequest>): Promise<CreateCountryResponse> {
    return apiClient.update<Partial<CreateCountryRequest>, CreateCountryResponse>(COUNTRIES_ENDPOINT, id, countryData);
  },

  /**
   * Delete a country by ID.
   */
  async deleteCountry(id: string): Promise<{ success: boolean; message: string }> {
    return apiClient.deleteById<{ success: boolean; message: string }>(COUNTRIES_ENDPOINT, id);
  },

  /**
   * Update display order for drag-and-drop reordering.
   */
  async updateCountryDisplayOrder(id: string, displayOrder: number) {
    return apiClient.patch<CreateCountryResponse>(`/countries/${id}/display-order`, { displayOrder });
  },
};
